import React from 'react';
import I18n from 'i18n-js';
import { I18N } from '@reverbdotcom/commons/src/components/translate';
import { RCCallout, RCButtonLink } from '@reverbdotcom/cadence/components';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { Paths } from '../shared/url_helpers';
import ShieldLight from '../../../images/shield-light.svg';

function ReverbPaymentsExpansionSellerOrdersBanner() {
  return (
    <div className="reverb-payments-expansion-seller-orders-banner">
      <RCCallout
        themeType="tempo"
        variant="tweed-high"
        image={ShieldLight}
        title={I18n.t('discovery.reverbPaymentsExpansionSellerOrdersBanner.title')}
        cta={(
          <RCButtonLink
            variant="dark"
            renderLink={c => (
              <CoreLink to={Paths.shopPoliciesEdit.expand({})} target="_blank" rel="noopener noreferrer">{c}</CoreLink>
            )}
          >
            {I18n.t('discovery.reverbPaymentsExpansionSellerOrdersBanner.updatePayoutSettings')}
          </RCButtonLink>
        )}
      >
        <p>
          <I18N text="discovery.reverbPaymentsExpansionSellerOrdersBanner.subtitle" />
          <span className="mobile-d-none">
            {' '}
            <I18N text="discovery.reverbPaymentsExpansionSellerOrdersBanner.moreText" />
          </span>
        </p>
      </RCCallout>
    </div>
  );
}

export default ReverbPaymentsExpansionSellerOrdersBanner;
